import "./contact-completion.d0a0cbcd.js";
import "./contact-completion.bb4bd49d.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("VPZwx", function(module, exports) {

$parcel$export(module.exports, "pageParams", function () { return $0adda7610463b65b$export$e1acdbbe7c24d88; });
$parcel$export(module.exports, "validationVariants", function () { return $0adda7610463b65b$export$1321ab7f525f446c; });
$parcel$export(module.exports, "validatePageParams", function () { return $0adda7610463b65b$export$35fc728d238c2fd3; });
$parcel$export(module.exports, "fetchData", function () { return $0adda7610463b65b$export$8134c072fddab6a5; });

var $hMTg2 = parcelRequire("hMTg2");

var $fiu1e = parcelRequire("fiu1e");

var $eMAh6 = parcelRequire("eMAh6");

var $8xm5I = parcelRequire("8xm5I");
const $0adda7610463b65b$var$MAX_NUMBER_OF_PHOTOS = 3000;
const $0adda7610463b65b$export$e1acdbbe7c24d88 = {
    resetData: ()=>localStorage.clear(),
    eventName: ()=>localStorage.getItem('eventName'),
    saveEventName: (eventName)=>localStorage.setItem('eventName', eventName),
    homeLink: ()=>localStorage.getItem('locWA'),
    saveHomeLink: (homeLink)=>localStorage.setItem('locWA', homeLink),
    attendeeUid: ()=>localStorage.getItem('attUidWA'),
    saveAttendeeUid: (attendeeUid)=>localStorage.setItem('attUidWA', attendeeUid),
    generatedAttId: ()=>localStorage.getItem('generatedAttId'),
    saveGeneratedAttId: (generatedAttId)=>localStorage.setItem('generatedAttId', generatedAttId)
};
/**
 * @typedef {Object} ValidationVariant
 * @property {Function} isValid - Function that returns true if validation passes
 * @property {String} message - Error message to display if validation fails
 */ /**
 * Make a validation variant
 *
 * @param isValid {Function}
 * @param message {String}
 * @returns {ValidationVariant}
 */ function $0adda7610463b65b$var$makeValidationVariant(isValid, message) {
    return {
        isValid: isValid,
        message: message
    };
}
const $0adda7610463b65b$export$1321ab7f525f446c = {
    isAssignedAttendeeUid: $0adda7610463b65b$var$makeValidationVariant(()=>$0adda7610463b65b$export$e1acdbbe7c24d88.attendeeUid() !== null, "We couldn't find your account information."),
    isSetUpEventName: $0adda7610463b65b$var$makeValidationVariant(()=>Boolean($0adda7610463b65b$export$e1acdbbe7c24d88.eventName()), 'The event code is missing or invalid.Please contact support for assistance.')
};
/**
 * Performs validation check on the provided validation list
 * @private
 * @param {ValidationVariant[]} validationList - Array of validation variants to check
 * @returns {ValidationVariant|null} The first failed validation, or null if all pass
 */ function $0adda7610463b65b$var$performValidation(validationList) {
    if (!Array.isArray(validationList) || validationList.length === 0) return {
        message: 'Invalid validation list provided'
    };
    return validationList.find((validation)=>{
        if (!validation || typeof validation.isValid !== 'function') return true;
        return !validation.isValid();
    }) || null;
}
/**
 * Handles validation error by displaying blocking error message
 * @private
 * @param {string} message - Error message to display
 */ function $0adda7610463b65b$var$handleValidationError(message) {
    (0, $8xm5I.showBlockingError)(message || 'Validation failed');
}
function $0adda7610463b65b$export$35fc728d238c2fd3(validationList) {
    const failedValidation = $0adda7610463b65b$var$performValidation(validationList);
    if (failedValidation) {
        $0adda7610463b65b$var$handleValidationError(failedValidation.message);
        return false;
    }
    return true;
}
const $0adda7610463b65b$export$8134c072fddab6a5 = {
    event: async (eventName = $0adda7610463b65b$export$e1acdbbe7c24d88.eventName())=>{
        const { result: result } = await (0, $hMTg2.findEvent)({
            eventName: eventName,
            basicDataOnly: true
        });
        if (!result) {
            (0, $8xm5I.showBlockingError)((0, $fiu1e.default).eventNotExist(eventName));
            return null;
        }
        return result;
    },
    photos: async (eventId, attUid = $0adda7610463b65b$export$e1acdbbe7c24d88.attendeeUid())=>new Promise((resolve, reject)=>{
            (0, $eMAh6.occoApi).photoListRetrieve('attendee_uid', attUid, eventId, null, null, null, $0adda7610463b65b$var$MAX_NUMBER_OF_PHOTOS, null, null, null, false, null, null, null, null, null, attUid, true, null, null, (err, result)=>{
                if (err) reject(err);
                else resolve(result);
            });
        })
};

});
parcelRegister("fiu1e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b22fd299625f64cb$export$2e2bcd8739ae039; });
var $b22fd299625f64cb$export$2e2bcd8739ae039 = {
    eventNotExist: (eName)=>`This "${eName}" event name (eName) doesn't exist. Please use right event name`
};

});


parcelRegister("bdrpf", function(module, exports) {

$parcel$export(module.exports, "setLogo", function () { return $82a62aebf9f4adac$export$760bdf29584b90d6; });
$parcel$export(module.exports, "setBackground", function () { return $82a62aebf9f4adac$export$2e65e79124cca55d; });

var $5OfWR = parcelRequire("5OfWR");
const $82a62aebf9f4adac$export$760bdf29584b90d6 = (src)=>(0, $5OfWR.initSetLogo)('.reg-logo__img', 'reg-logo__img_hidden', src);
function $82a62aebf9f4adac$export$2e65e79124cca55d(src) {
    const body = document.querySelector('.body');
    if (src) body.style.backgroundImage = `url(${src})`;
    else body.classList.add('body_background_second');
}

});

parcelRegister("11S0m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f61bd5989dcb282$export$2e2bcd8739ae039; });

var $kqCb6 = parcelRequire("kqCb6");

var $kyF38 = parcelRequire("kyF38");
var $6f61bd5989dcb282$export$2e2bcd8739ae039 = (0, $kyF38.init)((0, $kqCb6.default).init());

});
parcelRegister("kqCb6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68953a7b0cf7e87e$export$2e2bcd8739ae039; });

var $4OodJ = parcelRequire("4OodJ");
class $68953a7b0cf7e87e$export$2e2bcd8739ae039 {
    static init() {
        return new $68953a7b0cf7e87e$export$2e2bcd8739ae039();
    }
    constructor(){
        this.LIST_KEY = 'accountsList';
        this.INDEX_KEY = 'accountsCurrentIndex';
        this.listFallback = [];
        this.currentIndexFallback = -1;
        this.useListFallback = false;
        this.useCurrentIndexFallback = false;
        try {
            const parsedJSON = JSON.parse(localStorage.getItem(this.LIST_KEY)) || [];
            this.listFallback = Array.isArray(parsedJSON) ? parsedJSON.map((0, $4OodJ.makeAccount)) : [];
        } catch  {
            this.listFallback = [];
        }
        const parsedIndex = Number(localStorage.getItem(this.INDEX_KEY));
        if (!Number.isNaN(parsedIndex)) this.currentIndexFallback = parsedIndex;
        try {
            if (!localStorage.getItem(this.LIST_KEY)) localStorage.setItem(this.LIST_KEY, JSON.stringify(this.listFallback));
        } catch  {
            this.useListFallback = true;
        }
        try {
            if (!localStorage.getItem(this.INDEX_KEY)) localStorage.setItem(this.INDEX_KEY, String(this.currentIndexFallback));
        } catch  {
            this.useCurrentIndexFallback = true;
        }
    }
    getCurrentIndex() {
        if (this.useCurrentIndexFallback) return this.currentIndexFallback;
        const parsedIndex = Number(localStorage.getItem(this.INDEX_KEY));
        if (Number.isNaN(parsedIndex)) return this.currentIndexFallback;
        this.currentIndexFallback = parsedIndex;
        return parsedIndex;
    }
    setCurrentIndex(index) {
        this.currentIndexFallback = index;
        try {
            localStorage.setItem(this.INDEX_KEY, String(index));
            this.useCurrentIndexFallback = false;
        } catch  {
            this.useCurrentIndexFallback = true;
        }
    }
    getList() {
        if (this.useListFallback) return this.listFallback;
        try {
            const storedList = localStorage.getItem(this.LIST_KEY);
            if (storedList === null) return this.listFallback;
            const parsedJSON = JSON.parse(storedList) || [];
            this.listFallback = Array.isArray(parsedJSON) ? parsedJSON.map((0, $4OodJ.makeAccount)) : [];
            return this.listFallback;
        } catch  {
            return this.listFallback;
        }
    }
    setList(list) {
        this.listFallback = list.map((account)=>(0, $4OodJ.makeAccount)({
                ...account,
                email: account.email || ''
            }));
        try {
            localStorage.setItem(this.LIST_KEY, JSON.stringify(this.listFallback));
            this.useListFallback = false;
        } catch  {
            this.useListFallback = true;
        }
    }
}

});
parcelRegister("4OodJ", function(module, exports) {

$parcel$export(module.exports, "makeAccount", function () { return $90da0b922ad371f6$export$11be4f79df749898; });
$parcel$export(module.exports, "calculateExpiredDate", function () { return $90da0b922ad371f6$export$6c5f1943c09e93a1; });

var $eQ75S = parcelRequire("eQ75S");
const $90da0b922ad371f6$export$11be4f79df749898 = ({ attendeeUid: attendeeUid, eventCode: eventCode, eventLogo: eventLogo = '', name: name = '', email: email = '', phoneNumber: phoneNumber = '', regDate: regDate, expiredDate: expiredDate = null })=>({
        attendeeUid: attendeeUid,
        eventCode: eventCode,
        eventLogo: eventLogo,
        name: name,
        email: email,
        phoneNumber: phoneNumber,
        regDate: new Date(regDate),
        expiredDate: expiredDate ? new Date(expiredDate) : null
    });
const $90da0b922ad371f6$export$6c5f1943c09e93a1 = (event, attendee)=>event.photo_auto_delete_days ? (0, $eQ75S.addDays)(attendee.created_date, event.photo_auto_delete_days) : null;

});
parcelRegister("eQ75S", function(module, exports) {

$parcel$export(module.exports, "addDays", function () { return $835d1d9e78c794a9$export$dd412b56f1e4d8aa; });
$parcel$export(module.exports, "formatDate", function () { return $835d1d9e78c794a9$export$3ae94a2503e890a1; });
function $835d1d9e78c794a9$export$dd412b56f1e4d8aa(targetDate, days) {
    const date = new Date(targetDate);
    date.setDate(date.getDate() + days);
    return date;
}
function $835d1d9e78c794a9$export$3ae94a2503e890a1(date, userLocale = navigator.language) {
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    };
    return new Intl.DateTimeFormat(userLocale, options).format(date);
}

});



parcelRegister("kyF38", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $7914cf1a7c28278d$export$2cd8252107eb640b; });

var $4OodJ = parcelRequire("4OodJ");
function $7914cf1a7c28278d$export$2cd8252107eb640b(storage) {
    const subscriptionsOnChangeCurrentIndex = [];
    return {
        addAccount: addAccount,
        updateAccount: updateAccount,
        isExistsAccount: isExistsAccount,
        findIndex: findIndex,
        findIndexByEventCode: findIndexByEventCode,
        getList: getList,
        setCurrentAccount: setCurrentAccount,
        getCurrentAccount: getCurrentAccount,
        getCurrentIndex: getCurrentIndex,
        onChangeCurrentIndex: onChangeCurrentIndex,
        setList: setList
    };
    function addAccount(params) {
        const account = (0, $4OodJ.makeAccount)(params);
        storage.setList([
            account,
            ...getList()
        ]);
    }
    function updateAccount(account) {
        const list = [
            ...getList()
        ];
        const index = list.findIndex((acc)=>acc.attendeeUid === account.attendeeUid && acc.eventCode === account.eventCode);
        if (index > -1) {
            const currentAccount = list[index];
            const updatedAccount = {
                ...currentAccount,
                ...account
            };
            list[index] = updatedAccount;
            storage.setList(list);
        }
    }
    function getCurrentAccount() {
        return getList()[storage.getCurrentIndex()] || null;
    }
    function getCurrentIndex() {
        return storage.getCurrentIndex();
    }
    function setCurrentAccount(index) {
        storage.setCurrentIndex(index);
        subscriptionsOnChangeCurrentIndex.forEach((callback)=>callback(index));
    }
    function onChangeCurrentIndex(callback) {
        subscriptionsOnChangeCurrentIndex.push(callback);
    }
    function getList() {
        return storage.getList();
    }
    function setList(list) {
        storage.setList(list);
    }
    function findIndex({ attendeeUid: attendeeUid, eventCode: eventCode }) {
        return getList().findIndex((account)=>account.attendeeUid === attendeeUid && account.eventCode === eventCode);
    }
    function findIndexByEventCode(eventCode) {
        return getList().findIndex((account)=>account.eventCode === eventCode);
    }
    function isExistsAccount({ attendeeUid: attendeeUid, eventCode: eventCode }) {
        return findIndex({
            attendeeUid: attendeeUid,
            eventCode: eventCode
        }) > -1;
    }
}

});


parcelRegister("fZc1I", function(module, exports) {

$parcel$export(module.exports, "initEventOrganisationDataStorage", function () { return $ba35e1c48aa81ba0$export$e0729f1abb635550; });
function $ba35e1c48aa81ba0$export$e0729f1abb635550() {
    return {
        /**
     * Stores organisation domain data in localStorage.
     * If domain values exist, they are stored; if not, they are removed from localStorage.
     *
     * @param {Object} organisation - The organisation object containing domain information
     * @param {string} [organisation.photo_share_domain] - Photo share domain URL
     * @param {string} [organisation.webapp_domain] - Webapp domain URL
     */ storeEventOrganisationData (organisation) {
            if (!organisation || typeof organisation !== 'object') return;
            const domainFields = [
                {
                    key: 'photo_share_domain',
                    value: organisation.photo_share_domain
                },
                {
                    key: 'webapp_domain',
                    value: organisation.webapp_domain
                }
            ];
            domainFields.forEach(({ key: key, value: value })=>{
                if (value && typeof value === 'string' && value.trim()) localStorage.setItem(key, value.trim());
                else localStorage.removeItem(key);
            });
        },
        getPhotoShareDomainFromStorage () {
            return localStorage.getItem('photo_share_domain');
        },
        getWebappDomainFromStorage () {
            return localStorage.getItem('webapp_domain');
        },
        hasPhotoShareDomain () {
            return Boolean(localStorage.getItem('photo_share_domain'));
        },
        hasWebappDomain () {
            return Boolean(localStorage.getItem('webapp_domain'));
        }
    };
}

});


var $5EVEu = parcelRequire("5EVEu");

var $VPZwx = parcelRequire("VPZwx");

var $bdrpf = parcelRequire("bdrpf");

var $4iCXN = parcelRequire("4iCXN");

var $11S0m = parcelRequire("11S0m");

var $8xm5I = parcelRequire("8xm5I");

var $4OodJ = parcelRequire("4OodJ");

var $6wMuu = parcelRequire("6wMuu");

var $fZc1I = parcelRequire("fZc1I");
const $f85089982675fd41$var$eventOrganisationDataStorage = (0, $fZc1I.initEventOrganisationDataStorage)();
const { isSetUpEventName: $f85089982675fd41$var$isSetUpEventName } = (0, $VPZwx.validationVariants);
async function $f85089982675fd41$var$init() {
    (0, $5EVEu.prepareRegPage)();
    if (!(0, $VPZwx.validatePageParams)([
        $f85089982675fd41$var$isSetUpEventName
    ])) return;
    (0, $5EVEu.initPrivacyPolicyLink)();
    const event = await (0, $VPZwx.fetchData).event();
    if (!event) return;
    const { opts: opts } = event;
    await (0, $6wMuu.initEventLoc)(event);
    const form = (0, $5EVEu.initRegForm)();
    if (event.organisation) $f85089982675fd41$var$eventOrganisationDataStorage.storeEventOrganisationData(event.organisation);
    const { submitButton: submitButton, submitButtonText: submitButtonText } = (0, $5EVEu.initSubmitButton)();
    (0, $bdrpf.setLogo)(opts.webappCustomLogoSrc);
    (0, $bdrpf.setBackground)(opts.webappCustomBackgroundSrc);
    if (opts.webappIsEnabledSMS) form.enablePhoneNumber();
    if (await (0, $5EVEu.isNeedToShowPrivacy)()) form.enableAgreePrivacy();
    form.onSubmit(async ({ name: name, email: email, phoneNumber: phoneNumber })=>{
        if (submitButton) submitButton.textContent = (0, $6wMuu.t)('registration-submit-loading-label');
        try {
            const { result: attendeeUid } = await (0, $8xm5I.createAttendee)({
                eventCode: event.name,
                name: name,
                email: email,
                phoneNumber: phoneNumber
            });
            if (!attendeeUid) {
                if (submitButton) {
                    submitButton.textContent = submitButtonText;
                    submitButton.disabled = false;
                }
                alert((0, $5EVEu.getErrorRegFallBecauseOfAttendeeNull)({
                    canBeEmailConfirmationProblem: true
                }));
                return;
            }
            const regDate = new Date();
            (0, $11S0m.default).addAccount({
                attendeeUid: attendeeUid,
                eventCode: event.name,
                eventLogo: opts.webappCustomLogoSrc,
                name: name,
                email: email,
                phoneNumber: phoneNumber,
                regDate: regDate,
                expiredDate: (0, $4OodJ.calculateExpiredDate)(event, {
                    created_date: regDate
                })
            });
            (0, $11S0m.default).setCurrentAccount(0);
            (0, $4iCXN.redirectToPage).index({
                rawSearch: globalThis.location.search
            });
        } catch (error) {
            console.error('Error creating attendee:', error);
            if (submitButton) {
                submitButton.textContent = submitButtonText;
                submitButton.disabled = false;
            }
            throw error;
        }
    });
}
document.addEventListener('DOMContentLoaded', $f85089982675fd41$var$init);


//# sourceMappingURL=reg-user.d6cbe9d0.js.map
